module.exports = __webpack_public_path__ + "img/gray_delete.772017b4.svg";